import PreprocessAndRenderLatex from "../../../../components/ProcessRenderLatex";
import { useSelector } from "react-redux";
import { processLatex } from "../../../../utils/PreProcessorLatexCode";
import { marked } from "marked";
import { normalizeLatexToDoubleDollar } from "../dashboard/teacher/lessons/NewLessons/utils/fileHelpers";

function MCQsView({ options, student_answer, ai_answer, editGradeMode, setGetTeacherAnswer, getTeacherAnswer, loading }) {
  const globalState = useSelector((state) => state.globalState);


  const handleGetTeacherAnswer = (option) => {
    if (loading) return;
    if (!editGradeMode) return;
    setGetTeacherAnswer(option)
  }




  return (

    <div className="AssingmentMCQs-mock-test-answer-containe-wrapper">
      <div className="AssingmentMCQs-mock-test-answer-container">
        {options.includes(student_answer) && student_answer === ai_answer ? (
          <>
            <div className="correct-student-answer-wrapper hellOmkar">
              <p className={globalState?.role === "Student" ? 'AssingmentMCQs-answer-title' : 'AssingmentMCQs-answer-title-teacher'}>
                {globalState?.role === "Student" ? 'Your' : 'Student'} Answer - {String.fromCharCode(65 + options.indexOf(student_answer))}
              </p>
              {
                !editGradeMode &&
                <p className={globalState?.role === "Student" ? 'AssingmentMCQs-answer-title' : 'AssingmentMCQs-answer-title-teacher'}>
                  Correct Answer - {String.fromCharCode(65 + options.indexOf(ai_answer))}
                </p>
              }
            </div>
          </>
        ) : (
          <>
            <div className="correct-student-answer-wrapper">
              <p className={globalState?.role === "Student" ? 'AssingmentMCQs-wrong-answer-title' : 'AssingmentMCQs-wrong-answer-title-teacher'}>
                {`${globalState?.role === "Student" ? 'Your' : 'Student'} Answer - `}
                {student_answer !== null
                  ? String.fromCharCode(65 + options.indexOf(student_answer))
                  : '' // Show empty string if student_answer is null
                }
              </p>
              {
                !editGradeMode &&
                <p className={globalState?.role === "Student" ? 'AssingmentMCQs-answer-title' : 'AssingmentMCQs-answer-title-teacher'}>
                  {`Correct Answer - `}
                  {student_answer !== null
                    ? String.fromCharCode(65 + options.indexOf(ai_answer))
                    : '' // Show empty string if student_answer is null
                  }
                </p>
              }
            </div>
          </>
        )}
        <div className="options AssingmentMCQs-mock-test-answer-container" id="AssingmentMCQs-mock-test-answer">
          {options.map((option, index) => (
            <>
              <div
                className={`option AssignmentViewProgress-mock-test-answer-folder ${option === ai_answer
                  ? "correct !important"
                  : "incorrect !important"
                  }`}
                style={{
                  backgroundColor: getTeacherAnswer === option ? '#e6ffe5' : editGradeMode && 'white',
                  color: getTeacherAnswer === option ? '#28991f' : editGradeMode && 'black',
                  cursor: loading ? 'default' : (editGradeMode && 'pointer')
                }}
                onClick={() => {
                  handleGetTeacherAnswer(option);
                }}
                key={index}
              >
                <div style={{ paddingRight: "10px" }}>
                  {String.fromCharCode(65 + index) + ")"}
                </div>
                <div className="AssingmentMCQs-answer">
                  <PreprocessAndRenderLatex content={normalizeLatexToDoubleDollar(option) || `" "`} latexInline={true} />
                  {getTeacherAnswer === option ? <i class="fa-solid fa-check"></i> : (!editGradeMode && (option === ai_answer
                    ? <i class="fa-solid fa-check"></i>
                    : <i class="fa-solid fa-x"></i>))}
                </div>
              </div>
            </>

          ))}
        </div>
      </div>
    </div>
  );
}

export default MCQsView;